import testimonials from '@/data/testimonials'

class TestimonialsService {
  getAll (lang) {
    return testimonials[lang]
  }
}

export default new TestimonialsService()
